import React from 'react';
import { CtaButton } from './CtaButton';
import { Download, ShieldCheck, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-brand-yellow text-center" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-purpleDark mb-4 leading-tight" data-id="element-66">
          Tu freidora ya está lista.
        </h2>
        <p className="text-3xl md:text-4xl font-serif font-bold text-brand-purple mb-8" data-id="element-67">
          ¿Vos también?
        </p>

        <p className="text-xl text-brand-purpleDark font-medium mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-68">
          Dejá de improvisar en la cocina. Con este ebook tenés un sistema real
          para comer rico, rápido y sin perder tiempo pensando.
        </p>

        <CtaButton text="→ Accedé ahora por $6.999 ARS" variant="secondary" size="xl" className="w-full md:w-auto mb-8" data-id="element-69" />

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm font-semibold text-[#8B6B4A]" data-id="element-70">
          <div className="flex items-center gap-1" data-id="element-71">
            <Download className="w-4 h-4" data-id="element-72" /> Descarga inmediata
          </div>
          <div className="flex items-center gap-1" data-id="element-73">
            <ShieldCheck className="w-4 h-4" data-id="element-74" /> Garantía 5 días
          </div>
          <div className="flex items-center gap-1" data-id="element-75">
            <Zap className="w-4 h-4" data-id="element-76" /> Sin riesgos
          </div>
        </div>
      </div>
    </section>;
}